import dashboardDE from './dashboard';
import menuAboutDE from './menuAbout';
import labelsDE from './labels';
import releasesDE from './releases';
import artistsDE from './artists';
import artistsWishlistDE from './artistsWishlist';
import profileDE from './profile';
import musicLinksDE from './musicLinks';
import linkLandingPagesDE from './linkLandingPages';
import masteringDE from './mastering';
import featureDE from './feature';
import accountingDE from './accounting';
import paymentMethodsDE from './paymentMethods';
import purchaseHistoryDE from './purchaseHistory';
import trendsDE from './trends';
import earningsDrilldownDE from './earningsDrilldown';
import invoicesDE from './invoices';
import statementsDE from './statements';
import subuserStatementsDE from './subuserStatements';
import userDataFormDE from './userDataForm';
import creditsDE from './credits';
import disputeClaimsDE from './disputeClaims';
import musicLinkUrlPartsDE from './musicLinkUrlParts';
import subscriptionDE from './subscription';
import twoFactorAuthDE from './twoFactorAuth';
import generalDE from './general';
import routerDE from './router';
import escrowWalletDE from './escrowWallet';
import subUsersDE from './subUsers';
import tokensDE from './tokens';
import tracksDE from './tracks';
import acrAlertDE from './acrAlert';
import qcNoteDE from './qcNote';
import flaggedContentDE from './flaggedContent';
import deliveryConfirmationDE from './deliveryConfirmation';
import preScanDE from './preScan';
import accessKeysDE from './accessKeys';
import announcementsDE from './announcements';

const translationDE = {
    'router': routerDE,
    'general': generalDE,
    'dashboard': dashboardDE,
    'menuAbout': menuAboutDE,
    'labels': labelsDE,
    'artists': artistsDE,
    'artistsWishlist': artistsWishlistDE,
    'releases': releasesDE,
    'tracks': tracksDE,
    'profile': profileDE,
    'musicLinks': musicLinksDE,
    'musicLinkUrlParts': musicLinkUrlPartsDE,
    'linkLandingPages': linkLandingPagesDE,
    'mastering': masteringDE,
    'feature': featureDE,
    'accounting': accountingDE,
    'paymentMethods': paymentMethodsDE,
    'purchaseHistory': purchaseHistoryDE,
    'trends': trendsDE,
    'earningsDrilldown': earningsDrilldownDE,
    'invoices': invoicesDE,
    'statements': statementsDE,
    'subuserStatements': subuserStatementsDE,
    'credits': creditsDE,
    'userDataForm': userDataFormDE,
    'disputeClaims': disputeClaimsDE,
    'subscription': subscriptionDE,
    'twoFactorAuth': twoFactorAuthDE,
    'escrowWallet': escrowWalletDE,
    'subUsers': subUsersDE,
    'tokens': tokensDE,
    'acrAlert': acrAlertDE,
    'qcNote': qcNoteDE,
    'flaggedContent': flaggedContentDE,
    'deliveryConfirmation': deliveryConfirmationDE,
    'preScan': preScanDE,
    'accessKeys': accessKeysDE,
    'announcements': announcementsDE,
};

export default translationDE;
